module.exports = __webpack_public_path__ + "img/ico_member_change.c412b104.svg";